"use client";

import React, { useRef, useState } from "react";
import { Box } from "@mui/material";
import { WistiaPlayer } from "@wistia/wistia-player-react";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";

interface VideoModuleProps {
  videoInfo?: {
    videoTitle?: string;
    videoId?: string;
  };
}

const VideoModule = ({ videoInfo }: VideoModuleProps) => {
  const { videoId } = videoInfo || {};
  const playerRef = useRef<any>(null);
  const [showOverlay, setShowOverlay] = useState(true);

  return (
    <Box
      className="pattern-bg"
      data-track="visibility"
      data-module-name="Bottom Video Section"
      data-ranking-algorithm="manual"
      data-module-ranking-position="10"
      data-testid="video-module"
      component="section"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: { xs: "40px 24px", md: "60px 100px" },
        width: "100%"
      }}
    >
      {videoId && (
        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            width: { xs: "345px", sm: "852px", md: "1440px" },
            // height: { xs: "194px", sm: "px", md: "699px" },
            overflow: "hidden",
            borderRadius: "20px"
          }}
        >
          <WistiaPlayer
            ref={playerRef}
            mediaId={videoId}
            bigPlayButton={false}
            playBarControl={false}
            onPlay={() => setShowOverlay(false)}
            onPause={() => setShowOverlay(true)}
            volumeControl={false}
            roundedPlayer={10}
            settingsControl={false}
            fullscreenControl={false}
            playPauseControl={false}
            playPauseNotifier={false}
            controlsVisibleOnLoad={false}
            seo
            style={{ scale: "1.01" }}
          />
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "var(--theme-palette-common-white)",
              opacity: 0.8,
              cursor: "pointer"
            }}
          >
            {showOverlay && (
              <PlayCircleFilledWhiteOutlinedIcon
                onClick={() =>
                  setShowOverlay((prev) => {
                    if (prev) {
                      playerRef.current.play();
                    } else {
                      playerRef.current.pause();
                    }
                    return !prev;
                  })
                }
                sx={{ fontSize: 80 }}
              />
            )}
          </div>
        </Box>
      )}
    </Box>
  );
};

export default VideoModule;
